export default __webpack_public_path__ + "2ec0fdf7a027a2e38fe04bc08dcb4a48.png";